(function() {
  const sizeChartData = window.__sizeChartData__ || {};
  const container = document.getElementById('size-chart-display');
  if (!container) return;

  function updateSizeChart(variantId) {
    const chart = sizeChartData[String(variantId)];
    if (chart) {
      container.innerHTML = chart;
      container.style.display = '';
    } else {
      container.innerHTML = '';
      container.style.display = 'none';
    }
  }

  document.body.addEventListener('optionValueSelectionChange', function(e) {
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      const selectedId = variantSelects.dataset.selectedVariant
        || variantSelects.querySelector('[name="id"]')?.value;
      if (selectedId) updateSizeChart(selectedId);
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.matches('[name="id"]')) {
      updateSizeChart(e.target.value);
    }
  });
})();
